module.exports = __webpack_public_path__ + "static/media/thirdpersone-review.4da84024.png";